function closeTryOn () {
  const preview = document.getElementById("geenee-preview-container")
  if(preview) {
    preview?.remove()
  }
}

  window.addEventListener(
    "message",
    (event) => {
      if (event.data.action === "buy-button-clicked") {
        let formData = {
          'items': [{
            'id': event.data.id,
            'quantity': 1
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            return fetch(window.Shopify.routes.root + 'cart.js');
          })
        .then(()=> {
          closeTryOn()
        })
        .catch((error) => {
          console.error('Error:', error);
        });
        return;  
      }

    //   const isMobile = document.querySelector('.geenee-try-on-btn.mobile').getBoundingClientRect().width

      if (event.data.action === 'close-without-redirect'){
        console.log('close')
        const preview = document.getElementById("geenee-preview-container")
        preview?.remove();
        
        // if (isMobile){
        //   const element = document.querySelector('#select-options-form')
        //   element.scrollIntoView({ behavior: 'smooth' });
        // } 

        return;
      }
    }
  );

document.addEventListener('click', function(event) {
  const preview = document.getElementById('preview')
  var isClickInside = preview?.contains(event.target);

  if (preview && !isClickInside) {
    closeTryOn();
  }
});



function tryOnClick (event, _variantId, productId) {
    const searchParams = new URLSearchParams(document.location.search);
    const variantId = searchParams.get("variant")?.toLowerCase() || _variantId;
    console.log('id', variantId, productId);

    event.preventDefault();
    event.stopPropagation();
      const geeneeWrapper = document.createElement('div')
      geeneeWrapper.id = "geenee-preview-container"
      document.body.appendChild(geeneeWrapper)
      geeneeWrapper.innerHTML = `
        <div class="geenee-sticky-container">
            <iframe class="geenee-window" id="preview" allow="camera;microphone" src="https://projects.geen.ee/studson/?product=${productId}&variant=${variantId}&mode=ar"></iframe>
        </div>
      `
  }